import React from 'react';
import Error from 'Core/components/FormElements/Error';
import { useTranslation } from 'react-i18next';

const TermsInput = ({ onChange = () => { }, errors = {}, errorMessage, name, children, label }) => {
  const { t } = useTranslation();
  const error = errorMessage || errors?.[name]?.message;

  return (
    <>
      {label && <h4 className="font-semibold">{label}</h4>}
      <div className="">
        <div className="flex">
          <div>
            <input
              className="w-4 h-4 pr-2 text-orange-600 bg-orange-100 rounded border-orange-300  dark:ring-offset-gray-800 focus:ring-2 dark:bg-orange-700 dark:border-orange-600"
              id={name}
              data-testid="termsAndConditions"
              type="checkbox"
              name={name}
              onChange={onChange}
            />
          </div>
          <label className="text-sm m-0 pl-4 pr-2 overflow-auto w-full" htmlFor={name}>
            {children}
          </label>
        </div>
        <Error message={t('requiredAcceptTermsAndConditions')} show={Boolean(error)} />
      </div>
    </>
  );
};

export default TermsInput;
